'use strict';

angular.module('app.front', [
    'front',
    'route',
]);
